import Vue from "vue";
import { abilitiesPlugin } from "@casl/vue";
import { defineAbilityFor } from "@/utils/permissions";

Vue.use(abilitiesPlugin, defineAbilityFor());
